/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { AxiosResponse } from 'axios'
import { userInfoApi } from '@/api/login'
import { getRole } from '@/api/role'
import router from '@/router'
import { arrayToTree } from '@/utils/utils'

export interface UserInfo {
  id: string
  createTime: string
  updateTime: string
  userName: string
  phone: string
  password: string | null
  status: string
  dataType: string
  dataScope: string | null
  firmId: string
  roleId: string
  createUserId: string
  smsCode: string | null
  firmName: string | null
  roleName: string | null
  createUserName: string | null
  oldPwd: string | null
}

export const useUserStore = defineStore(
  'storeUserInfo',
  () => {
    const userInfo = ref<UserInfo>({
      id: '',
      createTime: '',
      updateTime: '',
      userName: '',
      phone: '',
      password: null,
      status: '',
      dataType: '',
      dataScope: null,
      firmId: '',
      roleId: '',
      createUserId: '',
      smsCode: null,
      firmName: null,
      roleName: null,
      createUserName: null,
      oldPwd: null,
    }) //用户基本信息

    const userRole = ref<any[]>([]) //用户的权限（菜单&按钮）
    const userPermissions = ref<string[]>([]) //用户的权限（按钮）数组
    const userName = ref('') //用户名称
    const userRoleFlat = ref<any[]>([]) //用户的权限（菜单&按钮）扁平数组
    const nowMenu = ref<any[]>(['/index']) //用户当前点击的菜单数组
    const routeData = ref<any[]>([]) //路由

    const setUserInfo = () => {
      userInfoApi().then((res: AxiosResponse) => {

        if (res.data.code == 200) {
          //储存用户信息
          userInfo.value = res.data.data
          userName.value = res.data.data.userName
          //获取当前用户的操作权限
          setUserPermission()
        }
      })
    }

    const setUserPermission = () => {
      getRole({ id: userInfo.value.roleId }).then((res: AxiosResponse) => {

        if (res.data.code == 200) {
          const data = res.data.data
          const menuArray = data.permissionList.map(
            (o: { parentId: string; name: string; type: string }) => {
              return {
                ...o,
                label: o.name,
                isPenultimate: o.type == 'menu' && o.parentId != '0' ? true : false,
              }
            },
          )
          userRoleFlat.value = menuArray
          userRole.value = arrayToTree(menuArray)
          userPermissions.value = data.permissionList
            .filter((o: { type: string }) => o.type == 'btn')
            .map((o: { label: string }) => o.label)
          router.push('/')
        }
      })
    }

    return {
      setUserInfo,
      userInfo,
      userRole,
      userName,
      userRoleFlat,
      nowMenu,
      routeData,
      userPermissions,
    }
  },
  {
    persist: true,
  },
)
